import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { CodeCheckBoxListModel } from '../../../list/code-check-box-list/code-check-box-list.model';
import { CodeListModel } from '../../../list/code-list/code-list.model';
import { CodeComboBoxModel } from '../code-combo-box.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCodeListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: CodeComboBoxModel|CodeCheckBoxListModel|CodeListModel;
  private codeDiv: string = null;
  private reserveNum1: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CodeDiv: this.codeDiv, ReserveNum1: this.reserveNum1
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel|CodeCheckBoxListModel|CodeListModel} model
   * @param {string} codeDiv
   * @param {string} reserveNum1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCodeListService
   */
  execute(model: CodeComboBoxModel|CodeCheckBoxListModel|CodeListModel, codeDiv: string, reserveNum1: string, successFunc: Function = null) {
      this.model = model;
    this.codeDiv = codeDiv;
    this.reserveNum1 = reserveNum1;
    this.successFunc = successFunc;
    this.send('KYMW02getCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateCodeList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
